import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(default)/page.tsx");
